export default {
    'please-select-a-filter': 'Please select a filter',
    customers: 'Customers',
    'external-entities': 'External entities',
    staff: 'Staff',
    state: "State"
}